<template>
    <div class="linkinfo" v-bind:class="{group: link.site == 'Link Group', slinkView: !isSlinkView}">
        <span v-if="link && link.clicks >=0 && !isSlinkView">{{ link.clicks | numeral('[0].[0(0)]a') }}<md-tooltip md-direction="top">CLICKS</md-tooltip></span>
        <!-- <span v-if="link && link.clicks >=0 && !isSlinkView"><md-icon class="click">touch_app</md-icon> {{link.clicks}}</span> -->
        <md-icon v-if="link && link.disabled" class="disabled">visibility_off<md-tooltip md-direction="top">DISABLED</md-tooltip></md-icon>
        <md-icon v-if="link && (link.forcedOrder !== undefined)  && !isSlinkView" class="forcedOrder">locked</md-icon>
        <md-icon v-if="link && link.site == 'Image' && !isSlinkView">crop_original</md-icon>
        <md-icon v-if="link && link.embed == 'Image' && !isSlinkView">code</md-icon>
        <md-icon v-if="link && link.quicklink && !isSlinkView" class="quicklink" style="color:gold">bolt</md-icon>
        <md-icon v-if="link && link.scheduled && !isSlinkView" class="quicklink">schedule<md-tooltip md-direction="top">SCHEDULED</md-tooltip></md-icon>
        <md-icon v-if="link && link.site =='Link Group' && !isSlinkView" class="quicklink">folder<md-tooltip md-direction="top">GROUP</md-tooltip></md-icon>
        <md-icon v-if="link && link.group && !isSlinkView" class="quicklink">account_tree<md-tooltip md-direction="top">IN GROUP</md-tooltip></md-icon>
        <md-icon v-if="link && (link.password)" class="password">locked</md-icon>
        <md-icon v-if="link && (link.onlyShowDomain) && !isSlinkView" class="password">vpn_lock</md-icon>

        <md-icon v-if="link && (link.passwordEmail)" class="password">mail_lock</md-icon>
        <md-icon v-if="link && (link.shake) && !isSlinkView" class="quicklink">vibration<md-tooltip md-direction="top">SHAKE</md-tooltip></md-icon>
        <md-icon v-if="link && (link.qrcode) && !isSlinkView" class="quicklink" style="color:black">qr_code<md-tooltip md-direction="top">QR Code</md-tooltip></md-icon>
        <!-- <span v-if="link && (link.passwordEmail)" style="color:white;">.</span> -->
        <span v-if="link && (link.copyOnly) && isSlinkView" style="color:black;">Click to Copy</span>
        <span v-if="link && link.site=='Link Group' && link.showChildCount" style="color:black;">{{childCount}}</span>

        <!-- <span v-if="link && (link.password || link.passwordEmail)" class="material-icons-outlined">
search
</span> -->
        <!-- <span  -->
        <span v-if="link && link.adult" class="adult">18+<md-tooltip md-direction="top">Sensitive Content</md-tooltip></span>
        <span v-if="link && link.info">{{link.info}}</span>
        <span v-if="text">{{text}}</span>
    </div>
</template>

<script>
    export default {
        props:{
            link: Object,
            childCount: String,
            text: String,
            isSlinkView: String,
        },
        data() {
            return {
            };
        },
        methods:{
        },
        created () {
          if(this.childCount){
            console.log('LinkInfo', this.link.description, this.childCount)

          }
  	// console.log(`ID PROPS INFO ${this.link.clicks}`)
        }
    }
</script>

<style scoped>
.linkinfo{
  border: 1px solid silver; 
  border-top: none; 
  border-right: none; 
  border-radius: 0px 0px 0px 10px; 
  line-height: 20px; 
  position: absolute; 
  /* top: 0px;  */
  right: 0px; 
  padding-right: 5px; 
  padding-left: 5px; 
  font-size: small; 
  font-weight:bold; 
  background-color: #ffffffbb; 
  color:black; 
  vertical-align: middle;
  z-index:5
}

.linkinfo .disabled{
  font-size:medium; color:darkred; width:16px; min-width:16px; height:unset; min-height:unset; margin-bottom: 1px;
}

.linkinfo .quicklink{
  font-size:medium; color:darkgreen; width:16px; min-width:16px; height:unset; min-height:unset; margin-bottom: 1px;
}

.linkinfo .password{
  font-size:medium; color:darkred; width:16px; min-width:16px; height:unset; min-height:unset; margin-bottom: 1px;
}

.linkinfo .forcedOrder{
  font-size:medium; color:black; width:16px; min-width:16px; height:unset; min-height:unset; margin-bottom: 1px;
}

.linkinfo .click{
  font-size:medium; color:darkgreen; width:16px; min-width:16px; height:unset; min-height:unset; margin-bottom: 1px;
}

/* .linkinfo .scheduled{
  font-size:medium; color:darkblue; width:16px; min-width:16px; height:unset; min-height:unset; margin-bottom: 1px;
} */

.linkinfo .adult{
  color:darkred
}

.group {
  top:0px
}

.slinkView{
  top:0px
}

/* .linkinfo span:nth-child(even):before {content: " / "; color:black} */

</style>


// WEBPACK FOOTER //
// src/components/linkinfo_component.vue